/** TOPページ 各 section の id */
export const TOP_SECTION_IDS = {
    case: 'top_case',
    column: 'top_column',
    contact: 'top_contact',
    detailed: 'top_detailed',
    mainVisual: 'top_main_visual',
    news: 'top_news',
    seeInNumber: 'top_see_in_number',
    seminar: 'top_seminar',
    serviceFlow: 'top_service_flow',
    serviceLead: 'top_service_lead',
    theme: 'top_theme',
    usageFee: 'top_usage_fee',
    useCompany: 'top_use_company',
    userVoice: 'top_user_voice',
};
